<template>
  <div class="vue-horizontal-timeline" :style="setTimelineStyles">
    <section class="timeline" id="scrollBox">
      <vue-seamless-scroll :data="items" :class-option="optionLeft" v-if="scrollFlag">
        <ol>
          <li v-for="(item, i) in items" :key="i" :style="setLineColor" :class="[
            { 'add-step': hasSlot || item[titleAttr] || item[contentAttr] },
            item.stepCssClass,
          ]">
            <div v-if="hasSlot || item[titleAttr] || item[contentAttr]" class="time"
              :class="[getTimeClass(item), item.boxCssClass]" @click="cardClicked(item)">
              <div v-viewer="{ title: false, button: true, navbar: true, url: 'mySrc' }" class="img_box">
                <img :src="item.resource" preview="1" :mySrc="item.extends.big_pic" />
              </div>
              <div class="text_box">
                <slot v-if="hasSlot" v-bind:item="item" v-bind:index="i" />
                <span class="subTitle" v-if="!hasSlot && item[titleAttr]" :class="getTitleClasses">
                  {{ textSubstr(item[titleAttr], titleSubstr) }}
                </span>
                <span class="content" v-if="!hasSlot && item[contentAttr]" :class="getContentClasses">
                  {{ textSubstr(item[contentAttr], contentSubstr) }}
                </span>
                <span class="time_span" :class="getContentClasses">
                  {{ item.time_span }}
                </span>
              </div>
              <!-- <div class="icon_origin"></div> -->
            </div>
            <div class="time_title">
              {{ item.date ? moment(item.date).format("YYYY-MM-DD") : "" }}
            </div>
          </li>
          <li :style="setLineColor"></li>
        </ol>
      </vue-seamless-scroll>
      <ol v-if="!scrollFlag">
        <li v-for="(item, i) in items" :key="i" :style="setLineColor" :class="[
          { 'add-step': hasSlot || item[titleAttr] || item[contentAttr] },
          item.stepCssClass,
        ]">
          <div v-if="hasSlot || item[titleAttr] || item[contentAttr]" class="time"
            :class="[getTimeClass(item), item.boxCssClass]" @click="cardClicked(item)">
            <div v-viewer="{ title: false, button: true, navbar: true, url: 'mySrc' }" class="img_box">
              <img :src="item.resource" preview="1" :mySrc="item.extends.big_pic" />
            </div>
            <div class="text_box">
              <slot v-if="hasSlot" v-bind:item="item" v-bind:index="i" />
              <span class="subTitle" v-if="!hasSlot && item[titleAttr]" :class="getTitleClasses">
                {{ textSubstr(item[titleAttr], titleSubstr) }}
              </span>
              <span class="content" v-if="!hasSlot && item[contentAttr]" :class="getContentClasses">
                {{ textSubstr(item[contentAttr], contentSubstr) }}
              </span>
              <span class="time_span" :class="getContentClasses">
                {{ item.time_span }}
              </span>
            </div>
            <!-- <div class="icon_origin"></div> -->
          </div>
          <div class="time_title">
            {{ item.date ? moment(item.date).format("YYYY-MM-DD") : "" }}
          </div>
        </li>
        <li :style="setLineColor"></li>
      </ol>
    </section>
  </div>
</template>

<script>
import * as moment from "moment";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "VueHorizontalTimeline",
  data() {
    return {
      moment,
    };
  },
  components: {
    vueSeamlessScroll,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    srcList: {
      type: Array,
      default: [],
    },
    itemSelected: {
      type: Object,
      default: () => ({}),
    },
    itemUniqueKey: {
      type: String,
      default: "",
    },
    titleAttr: {
      type: String,
      default: "title",
    },
    titleCentered: {
      type: Boolean,
      default: false,
    },
    titleClass: {
      type: String,
      default: "",
    },
    titleSubstr: {
      type: Number,
      default: 18,
    },
    contentAttr: {
      type: String,
      default: "subTitle",
    },
    time_span: {
      type: String,
      default: "time_span",
    },
    contentCentered: {
      type: Boolean,
      default: false,
    },
    scrollFlag: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: "",
    },
    contentSubstr: {
      type: Number,
      default: 250,
    },
    minWidth: {
      type: String,
      default: "200px",
    },
    minHeight: {
      type: String,
      default: "",
    },
    timelinePadding: {
      type: String,
      default: "",
    },
    timelineBackground: {
      type: String,
      default: "",
    },
    lineColor: {
      type: String,
      default: "#dddddd",
    },
    clickable: {
      type: [String, Boolean],
      default: true,
    },
    mouseFlag: {
      type: Boolean,
      default: false,
    }
  },
  emits: ["click", "update:itemSelected"],
  mounted() {

    this.scrollInit();
  },
  computed: {
    optionLeft() {
      return {
        step: 1,
        direction: 2, // 0向下 1向上 2向左 3向右
        limitMoveNum: 1,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        // openTouch: false,
        openWatch: true,
      };
    },
    hasSlot() {
      return "$scopedSlots" in this && this.$scopedSlots?.default
        ? true
        : !!this.$slots?.default;
    },
    setTimelineStyles() {
      const { timelineBackground, timelinePadding } = this;
      const styleObj = {};
      if (timelinePadding) {
        styleObj.padding = timelinePadding;
      }
      if (timelineBackground) {
        styleObj.background = timelineBackground;
      }
      return styleObj;
    },
    setLineColor() {
      const { lineColor } = this;
      return lineColor ? `background: ${lineColor}` : "";
    },
    /*  getTimeStyles() {
      const { minWidth, minHeight, clickable } = this;
      const styleObj = {
        minWidth,
        minHeight,
      };
      if (!clickable) {
        styleObj.cursor = "default";
      }
      return styleObj;
    }, */
    getTitleClasses() {
      const { titleClass, titleCentered } = this;
      return titleClass || { "text-center": titleCentered };
    },
    getContentClasses() {
      const { contentClass, contentCentered } = this;
      return contentClass || { "text-center": contentCentered };
    },
  },
  methods: {
    textSubstr(value, qtd = 250, mask = "...") {
      return value;
    },
    cardClicked(item) {
      if (!this.clickable) {
        return;
      }
      this.$emit("update:itemSelected", { ...item });
      this.$emit("click", item);
    },
    getTimeClass(item) {
      const { itemUniqueKey, itemSelected } = this;
      if (itemUniqueKey && itemSelected) {
        return {
          "border-blue": item[itemUniqueKey] === itemSelected[itemUniqueKey],
        };
      }
      return {};
    },
    scrollInit() {
      if (!this.mouseFlag) {
        return;
      }
      // 获取要绑定事件的元素
      const nav = document.getElementById("scrollBox")
      var flag; // 鼠标按下
      var downX; // 鼠标点击的x下标
      var scrollLeft; // 当前元素滚动条的偏移量
      nav.addEventListener("mousedown", function (event) {
        flag = true;
        downX = event.clientX; // 获取到点击的x下标
        scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
      });
      nav.addEventListener("mousemove", function (event) {
        if (flag) { // 判断是否是鼠标按下滚动元素区域
          var moveX = event.clientX; // 获取移动的x轴
          var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
          this.scrollLeft = scrollLeft - scrollX // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
          console.log(scrollX)
        }
      });
      // 鼠标抬起停止拖动
      nav.addEventListener("mouseup", function () {
        flag = false;
      });
      // 鼠标离开元素停止拖动
      nav.addEventListener("mouseleave", function (event) {
        flag = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes triangle-odd {
  100% {
    filter: drop-shadow(4px 2px 1px rgba(0, 0, 0, 0.2)) drop-shadow(2px 4px 0px rgba(0, 0, 0, 0.14));
  }
}

@keyframes triangle-even {
  100% {
    filter: drop-shadow(4px -1px 1px rgba(0, 0, 0, 0.2));
  }
}

.vue-horizontal-timeline {
  position: relative;
  width: 100%;

  .text-center {
    text-align: center;
  }

  .timeline {
    white-space: nowrap;
    overflow-x: auto;
    padding: 2em 0;
    height: inherit;
    scrollbar-width: thin;
    scrollbar-color: rgba(155, 155, 155, 0.7) rgba(255, 255, 255, 0.5);
    margin: 0 0px 0 100px;
    overflow: hidden;

    .subTitle {
      width: 260px;
      display: block;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 15px;
      white-space: normal;
      font-family: "PingFang_Regular";
      display: -webkit-box;
      /* 使用WebKit的弹性盒子模型 */
      -webkit-line-clamp: 2;
      /* 限制文本行数为3行 */
      -webkit-box-orient: vertical;
      /* 设置弹性盒子模型的方向为垂直 */
      overflow: hidden;
      /* 隐藏超出容器的内容 */
      text-overflow: ellipsis;
      /* 显示省略号 */
    }

    .content {
      display: block;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
      opacity: 0.6;
      width: 260px;
      white-space: normal;
      display: -webkit-box;
      /* 使用WebKit的弹性盒子模型 */
      -webkit-line-clamp: 3;
      /* 限制文本行数为3行 */
      -webkit-box-orient: vertical;
      /* 设置弹性盒子模型的方向为垂直 */
      overflow: hidden;
      /* 隐藏超出容器的内容 */
      text-overflow: ellipsis;
      /* 显示省略号 */
    }

    .time_span {
      /*       display: block;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
      opacity: 0.6; */
    }

    .icon_origin {
      width: 43px;
      height: 9px;
      background: #f7931e;
      border-radius: 5px;
    }

    ol {
      font-size: 0;
      width: 100%;
      padding: 310px 0 310px 0px;
      transition: all 0.5s;

      li {
        position: relative;
        display: inline-block;
        list-style-type: none;
        width: 381px;
        height: 1px;
        background: #dddddd;

        &:last-child {
          width: 300px;
        }

        &.add-step:not(:last-child) {
          padding-right: 0px;
          margin-right: 0px;

          &::after {
            content: "";
            position: absolute;
            left: calc(100% - 140px);
            bottom: -0.0573rem;
            transform: translateY(-70%);
            border-radius: 50%;
            width: 7px;
            height: 7px;
            background: #d8d8d8;
            border: 1px solid #fff;
          }
        }

        .time {
          position: absolute;
          display: flex;
          left: 1em;
          font-size: 26px;
          // white-space: normal;
          color: black;
          transition: 0.2s all ease-out;
          cursor: pointer;
          padding-bottom: 20px;
        }

        .img_box {

          // overflow: hidden;
          .el-image {
            // border-radius: 23px;
            box-shadow: 0px 6px 6px 6px rgba(243, 239, 239, 0.1);
            border-radius: 8px !important;
            width: 432px;
            height: 239px;
          }

          img {
            box-shadow: 0px 6px 6px 6px rgba(243, 239, 239, 0.1);
            border-radius: 8px !important;
            width: 432px;
            height: 239px;
          }
        }

        &:nth-child(even) {
          .time {
            top: calc(100% + 58px);

            &::before {
              top: -58px;
            }

            &:hover {
              &::before {
                animation: triangle-even 0.2s both;
              }
            }
          }

          .time.border-blue {
            filter: drop-shadow(-1px 0px 0 #dddddd) drop-shadow(1px 1px 0 #dddddd) drop-shadow(0px -1px 0 #dddddd);
          }
        }

        &:nth-child(odd) {
          .time {
            // top: -58px;
            transform: translateY(-100%);
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            border-top-left-radius: 3px;

            &::before {
              top: 100%;
              border-width: 8px 8px 0 0;
              border-color: white transparent transparent transparent;
              filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.2)) drop-shadow(1px 1px 0px rgba(0, 0, 0, 0.14));
            }

            &:hover {
              &::before {
                animation: triangle-odd 0.2s both;
              }
            }
          }

          .time.border-blue {
            filter: drop-shadow(-1px 0px 0 #dddddd) drop-shadow(1px 1px 0 #dddddd) drop-shadow(0px -1px 0 #dddddd);
          }
        }

        .time_title {
          position: absolute;
          padding: 25px 0px 0 202px;
          font-size: 16px;
          opacity: 0.4;
          // white-space: normal;
          color: black;
          transition: 0.2s all ease-out;
          text-align: center;
        }
      }
    }
  }
}

.timeline::-webkit-scrollbar {
  height: 0px;
}

.timeline::-webkit-scrollbar-thumb {
  background-color: rgba(155, 155, 155, 0.7);
  border-radius: 3px;
}

.text_box {
  padding: 20px 0 0 12px;
}
</style>

<style>
.el-image-viewer__wrapper .el-image-viewer__btn {
  display: none !important;
}

.pswp__bg {
  background: rgba(255, 255, 255, 0.7) !important;
}
</style>
